import { useCart } from '../context/CartContext';
import { CartItemRow } from './CartItem';
import { useI18n } from '../i18n';

export function CartDrawer() {
  const { items, totalPrice, setView } = useCart();
  const { t } = useI18n();

  return (
    <div className="hc-cart">
      <div className="hc-cart-header">
        <button className="hc-back-btn" onClick={() => setView('menu')}>
          &larr; {t('cart.back')}
        </button>
        <h2>{t('cart.title')}</h2>
      </div>

      {items.length === 0 ? (
        <div className="hc-cart-empty">
          <p>{t('cart.empty')}</p>
          <button className="hc-btn hc-btn-secondary" onClick={() => setView('menu')}>
            {t('nav.menu')}
          </button>
        </div>
      ) : (
        <>
          <div className="hc-cart-items">
            {items.map((ci) => (
              <CartItemRow key={ci.uid} cartItem={ci} />
            ))}
          </div>

          <div className="hc-cart-footer">
            <div className="hc-cart-total">
              <span>{t('cart.total')}</span>
              <span className="hc-cart-total-price">{totalPrice.toFixed(2)} &euro;</span>
            </div>
            <button className="hc-btn hc-btn-primary hc-btn-block" onClick={() => setView('checkout')}>
              {t('cart.checkout')}
            </button>
          </div>
        </>
      )}
    </div>
  );
}
